import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const Materials = () => import('./pages');

const moduleRoute = {
  path: 'master-data/materials',
  name: 'Materials',
  component: Materials,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.PRODUCTS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
